/* eslint-disable */
import ctype from 'component-type';
import stripIndent from '../../Vendor/strip-indent';

/**
 * Thrown when the supplied `locale` is invalid
 * @export
 * @class I18nInvalidLocaleTypeError
 * @extends {Error}
 */
export class I18nInvalidLocaleTypeError extends Error {
  /**
   * Creates an instance of I18nInvalidLocaleTypeError
   * @param {string} message The Error `message`
   * @memberof I18nInvalidLocaleTypeError
   */
  constructor(message) {
    super(message);
    this.name = `I18nInvalidLocaleTypeError`;
  }
}

/**
 * Called when the supplied `locale` is invalid
 * @param {any} locale The invalid `locale`
 * @param {string} ltr The `ltr` value
 * @param {string} rtl The `rtl` value
 * @returns {never} never
 */
const throwI18nInvalidLocaleTypeError = (locale, ltr, rtl) => {
  let newLocale = locale;
  try {
    newLocale = JSON.stringify(newLocale, null, 2)
      .split(`\n`)
      .join(`\n    `);
  } catch (error) {
    /* do nothing */
  }
  throw new I18nInvalidLocaleTypeError(
    stripIndent(`
    Expected "locale" to be of type Object.
    Got: "${ctype(locale)}".

    The "locale" should have the following shape

    type Locale = {
      direction: '${ltr}' | '${rtl}';
      label: string;
      lang: string;
      shortLabel: string;
    }

    Note: "locale.label", "locale.lang", and "locale.shortLabel" should have a "length" greater than "0"

    Got shape:
    ${newLocale}
    `),
  );
};

export default throwI18nInvalidLocaleTypeError;
